export const TestType = {
  MOCA: 'moca_visual',
  MIS: 'mis',
};
